import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { useNavigate, useParams } from "react-router";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import InvoiceHeader from "../../Accounts/Client invoice PDF tables/invoice_header";
import {
  convertRupeesToWords,
  roundOffCost,
} from "../../../Components/Functions/amt.fun";

const PreviewPaymentReceipt = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const printPDF = (clientName) => {
    let name = `${clientName}-invoice-pdf`;
    document.title = name;
    window.print();
  };
  useEffect(() => {
    performRequest("GET", `/incentive/getIncentiveById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.revenueApproved === "Approved") {
            let newTotal = "";
            if (res?.data?.sellsType == "physical site inspection") {
              newTotal = res?.data?.actualSIAmount;
            } else {
              if (!isNaN(+res?.data?.preGstAmount)) {
                newTotal = +res?.data?.preGstAmount
                  ? +res?.data?.preGstAmount * (1 + 18 / 100)
                  : 0;
              }
            }
            setData({ ...res.data, newTotal });
          } else {
            Toast(
              "error",
              "Receipt cannot be generated until the revenue is approved."
            );
            navigate("/revenue-management");
          }
        } else {
          Toast("error", "Error while getting Incentive Information!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [id]);

  const style = {
    border: "1px solid #181818",
    textAlign: "left",
    margin: "2px",
    padding: "0px",
    paddingLeft: "3px",
    fontSize: "12px",
    borderCollapse: "collapse",
  };
  useEffect(() => {
    const TR = document.getElementsByTagName("tr");
    const TH = document.getElementsByTagName("th");
    const TD = document.getElementsByTagName("td");
    const H3 = document.getElementsByTagName("h3");

    Array.from(TR).forEach((tr) => {
      Object.assign(tr.style, style);
    });
    Array.from(TH).forEach((th) => {
      Object.assign(th.style, style);
    });
    Array.from(TD).forEach((td) => {
      Object.assign(td.style, style);
    });
    Array.from(H3).forEach((h3) => {
      Object.assign(h3.style, {
        marginTop: "14px",
        marginBottom: "2px",
      });
    });
  }, []);

  const getStatus = (inp) => {
    switch (inp?.toLowerCase()) {
      case "allother":
        return "Purchase of Hydroponic Home Kit";

      case "hydroponic masterclass":
        return "Registration for the Hydroponic Masterclass";

      case "practical training":
        return "Practical Hydroponic Training";

      case "physical site inspection":
        return "Physical Site Inspection services";

      case "construction payment":
        return "Development of Hydroponic Farming Setup";

      case "project conversion":
        return "Development of Hydroponic Farming Setup";

      case "site inspection kit":
        return "Purchase of the Site Inspection Kit";

      case "aif project report":
        return "Preparation of the AIF Project Report";

      default:
        return "Purchase of Hydroponic Home Kit";
    }
  };
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div
            className="page-header d-print-none"
            style={{ borderBottom: "1px solid #181818", marginBottom: "20px" }}
          >
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">Client Invoice Management</h2>
                <h4 className="text-danger">
                  Please check the client details, payment received date,
                  particulars, and amount before generating the receipt voucher.
                </h4>
              </div>
              <div className="col-auto ms-auto d-print-none">
                <div className="d-flex">
                  <SimpleButton
                    buttonText={"Save Pdf"}
                    onClick={() => printPDF(data?.leadName)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card-body" style={{ color: "black" }}>
            <InvoiceHeader />
            <div>
              <h1 style={{ textAlign: "center" }}>RECEIPT VOUCHER</h1>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                {/* Received From */}
                <div style={{ maxWidth: "40%" }}>
                  <p>
                    Received From: <b>{data?.leadName}</b>
                    <br />
                    Address:{" "}
                    <b>
                      {data?.farm_construction_location
                        ? `${data?.farm_construction_location} ${
                            data?.farm_construction_state
                              ? `, ${data?.farm_construction_state}`
                              : ""
                          }`
                        : "N/A"}
                    </b>
                  </p>
                </div>

                {/* Voucher Details */}
                <div>
                  <p>
                    Receipt Voucher No.: <b>{`RV/2026-27/${id}`}</b>
                    <br />
                    Date: <b>{data?.paymentDate || "N/A"}</b>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <p style={{ marginTop: "15px", textAlign: "justify" }}>
                Received an amount of{" "}
                <b>{roundOffCost(data?.preGstAmount ? data?.newTotal : 0)}</b>{" "}
                towards the <b>{getStatus(data?.sellsType)}</b> as per the terms
                agreed between the parties.
                <br />
                <br />
                The amount received is provisional in nature and shall be
                adjusted against the final tax invoice to be issued upon
                completion of the agreed services or achievement of the relevant
                milestone.
              </p>
            </div>
            <div>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid #181818",
                }}
              >
                <thead style={{ backgroundColor: "#e8e9eb" }}>
                  <tr>
                    <td
                      style={{
                        width: "2%",
                        border: "1px solid #181818",

                        fontWeight: "bolder",
                      }}
                      className="p-1 fs-4"
                    >
                      Sr.
                    </td>
                    <td
                      className="p-1 fs-4"
                      style={{
                        width: "20%",

                        border: "1px solid #181818",
                        fontWeight: "bolder",
                      }}
                    >
                      Particulars
                    </td>

                    <td
                      className="p-1  fs-4"
                      style={{
                        width: "8%",

                        border: "1px solid #181818",
                        fontWeight: "bolder",
                      }}
                    >
                      Date
                    </td>

                    <td
                      className="p-1  fs-4"
                      style={{
                        width: "8%",

                        border: "1px solid #181818",
                        fontWeight: "bolder",
                      }}
                    >
                      Amount
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td
                      className="p-1  fs-4"
                      style={{ border: "1px solid #181818" }}
                    >
                      1
                    </td>
                    <td
                      className="p-1  fs-4"
                      style={{ border: "1px solid #181818" }}
                    >
                      {getStatus(data?.sellsType)}
                    </td>

                    <td
                      className="p-1  fs-4"
                      style={{ border: "1px solid #181818" }}
                    >
                      {data?.paymentDate || "N/A"}
                    </td>
                    <td
                      className="p-1  fs-4"
                      style={{ border: "1px solid #181818" }}
                    >
                      {roundOffCost(data?.preGstAmount ? data?.newTotal : 0)}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                style={{ width: "100%", border: "none", marginTop: "2px" }}
              >
                <tbody>
                  <tr style={{ border: "none" }}>
                    <td
                      style={{
                        border: "none",
                        width: "60%",
                        verticalAlign: "bottom",
                        padding: "3px",
                      }}
                    >
                      <p style={{ padding: "5px" }}>
                        <span className="fs-3">In Words:</span>{" "}
                        <b style={{ fontSize: "0.9rem" }}>
                          {convertRupeesToWords(
                            data?.preGstAmount ? data?.newTotal : 0
                          )}
                        </b>
                      </p>
                    </td>
                    <td
                      style={{
                        border: "none",
                        width: "40%",
                        verticalAlign: "top",
                        padding: "3px",
                      }}
                    >
                      <img
                        width="60%"
                        src={
                          "https://res.cloudinary.com/bsgfcooa/image/upload/v1753079878/signature_cztq8j_p5hwwc_me2vci.png"
                        }
                        alt="signature"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PreviewPaymentReceipt;
